import { FormEvent, useEffect, useState } from "react";

import { Link } from "react-router-dom";
import ProviderNavigation from "./ProviderNavigation";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";
import { selectIsLoggedIn } from "../../../src/redux/app";
import { useAppSelector } from "../../../src/redux/hooks";

const Login = () => {
  const [email, setEmail] = useState("");
  const isLoggedIn = useAppSelector(selectIsLoggedIn);

  // Clear stale session state so useAuth falls back to roles[0] after login.
  useEffect(() => {
    localStorage.removeItem("activeRole");
  }, []);
  const submitEmail = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (email != null) {
      window.location.href =
        "/graphql/passwordless-auth?email=" + encodeURIComponent(email);
    }
  };

  return (
    <>
      {!isLoggedIn && <ProviderNavigation />}
      <div className="wrapper">
        <div className="row" id="login_row">
          <div className="tw-mx-auto tw-w-1/3 1040:tw-w-[90%]">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Log in as Provider</h3>
              </div>
              <div id="existing-customer" className="panel-body">
                <form onSubmit={(event) => submitEmail(event)}>
                  <input
                    type="email"
                    id="login-email"
                    className="login-email"
                    placeholder="Enter your email..."
                    onChange={(event) => setEmail(event?.target.value)}
                  />
                  <StandardButton
                    className="tw-w-full tw-text-[16px]"
                    style="primary-blue"
                    onClick={() => {}}
                  >
                    Continue with email
                  </StandardButton>
                </form>
              </div>
            </div>

            <div className="password-login-link">
              <Link to="/password-login?type=provider">
                Log in with a password instead
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
